import { animated, useSpring } from '@react-spring/web';
import { Typography, useMobile } from '@sonnen/web-ui';
import { parseHtmlTags } from '@sonnen/web-utils';
import { createElement } from 'react';
import Plant from '../../assets/Plant';
import styles from './FullContentMessage.module.css';

type Props = {
  children?: React.ReactNode;
  title?: string;
  text?: string;
  dataTestId?: string;
};

export const FullContentMessage = ({ children, title, text, dataTestId }: Props) => {
  const mobile = useMobile();
  const props = useSpring({
    from: { opacity: 0.4, scale: 0.98 },
    to: { opacity: 1, scale: 1 },
    config: { tension: 200, friction: 20 },
  });

  return (
    <animated.div className={styles.fullContentMessage} data-testid={dataTestId} style={props}>
      <br />
      <Plant />
      {title && createElement(Typography[mobile ? 'H1' : 'Display'], undefined, title)}
      {text && (
        <div className={styles.text}>
          <Typography.Body1>{parseHtmlTags(text)}</Typography.Body1>
        </div>
      )}
      {children}
    </animated.div>
  );
};
